const $ = require("../../node_modules/jquery/dist/jquery.min")

module.exports = {
  init: () => {
    const trigger = $(".loginmenu-trigger")
    const loginMenu = $("#loginmenu")

    const openLoginMenu = () => {
      loginMenu.addClass("dropdown--active")
      trigger.addClass("header-tools-item--active")
    }
    const closeLoginMenu = () => {
      loginMenu.removeClass("dropdown--active")
      trigger.removeClass("header-tools-item--active")
    }

    $(document).on("click", function(e) {
      if ($(e.target).closest("#loginmenu").length === 0) {
        closeLoginMenu()
        // return false
      }
    })
    trigger.on("click", function(e) {
      if (loginMenu.hasClass("dropdown--active")) {
        closeLoginMenu()
      } else {
        openLoginMenu()
      }
      return false
    })
  },
}
